import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root:
            'relative flex min-h-24 w-full items-center justify-center rounded-(--border-radius-md) border-2 ' +
            'border-dashed border-(--slate-muted-alpha-35) bg-(image:--surface-frosted-bg) px-6 py-5',
        content: 'flex items-center gap-4',
        iconWrap:
            'flex h-11 w-11 shrink-0 items-center justify-center rounded-full ' +
            'bg-[linear-gradient(145deg,#f0f2f7,#dce0e8)]',
        icon: 'h-[1.35rem] w-[1.35rem] text-(--accent-solid)',
        textWrap: 'flex flex-col gap-[0.15rem]',
        title: 'text-[0.925rem] font-semibold text-(--text-strong)',
        subtitle: 'text-[0.78rem] font-medium text-(--text-muted)',
        clearButton: 'absolute right-3 top-3'
    },
    variants: {
        loading: {
            true: {
                root: 'pointer-events-none cursor-not-allowed opacity-[0.6]'
            },
            false: {
                root: 'cursor-pointer'
            }
        }
    }
} satisfies ComponentTheme;
